import React from 'react'
import { useState } from 'react'
import Logo from '../images/logo.png'
const Header = () => {
  const [navbarOpen, setNavbarOpen] = useState(false)
  return (
    <header  className=" absolute sticky left-0 top-0 z-50 bg-white/90 w-full backdrop-blur">
      <div className="mx-auto h-[90px] max-w-7xl px-8 md:px-6">
          <div className="relative flex h-full items-center justify-between border-b border-slate-500/10">
              {/* <!-- logo --> */}
              <div className="w-[15rem] max-w-full">
                  <a href="#">
                      <img src={Logo} alt="logo" className="w-full" />
                  </a>
              </div>

              <div className="flex w-full items-center justify-between">
                {/* x-transition :className="!navbarOpen && 'hidden'" */}
                  <nav  id="navbarCollapse" className={`${!navbarOpen && 'hidden'} absolute right-0 top-[90px] w-full max-w-[350px] rounded-lg border border-blue-200 bg-white py-5 px-6 shadow-lg shadow-blue-400/5 transition-all lg:static lg:block lg:max-w-full lg:border-none lg:shadow-none lg:bg-transparent lg:px-0 lg:py-0`}>
                      <ul className="flex flex-col justify-center gap-8 lg:flex-row">
                          <li>
                              <a href="#home" className="text-lg font-medium text-slate-700 duration-200 hover:text-blue-600 lg:text-base">Home</a>
                          </li>
                          <li>
                              <a href="#about" className="text-lg font-medium text-slate-700 duration-200 hover:text-blue-600 lg:text-base">About</a>
                          </li>
                          <li>
                              <a href="#services" className="text-lg font-medium text-slate-700 duration-200 hover:text-blue-600 lg:text-base">Services</a>
                          </li>
                          <li>
                              <a href="#portfolio" className="text-lg font-medium text-slate-700 duration-200 hover:text-blue-600 lg:text-base">Portfolio</a>
                          </li>
                          <li>
                              <a href="#blog" className="text-lg font-medium text-slate-700 duration-200 hover:text-blue-600 lg:text-base">Blog</a>
                          </li>
                          <li>
                              <a href="#contact"  className="text-lg font-medium text-slate-700 duration-200 hover:text-blue-600 lg:text-base">Contact</a>
                          </li>
                      </ul>
                  </nav>
              </div>
              {/* <!-- menu btn --> */}
              <div className="flex">
                  <a href="#" className="mr-10 hidden rounded-md bg-blue-500 px-8 py-2.5 font-semibold text-white shadow-md shadow-blue-500/20 duration-200 hover:bg-blue-600 sm:block lg:mr-0">Register</a>
{/* @click="navbarOpen = !navbarOpen" :className="navbarOpen && 'navbarTogglerActive'" */}
                  <button onClick={()=>setNavbarOpen(!navbarOpen)} id="navbarToggler" className={`block lg:hidden  ${navbarOpen && 'navbarTogglerActive'}`}>
                      <ion-icon name="menu-outline" className="text-4xl text-blue-500"></ion-icon>
                  </button>
              </div>
          </div>
      </div>
  </header>
  )
}

export default Header